import React from 'react'
import { Helmet } from 'react-helmet'
import PhotoHolder from '../components/photo-holder'
import { Link } from 'react-router-dom'
import './photo-instructions.css'

const PhotoInstructions = (props) => {
  return (
    <div className="photo-instructions-container">
      <Helmet>
        <title>Photo-instructions - Hackathon</title>
        <meta property="og:title" content="Photo-instructions - Hackathon" />
      </Helmet>
      <div className="photo-instructions-container1">
        <h1 className="photo-instructions-text">How to take a good picture</h1>
        <ul className="list photo-instructions-ul">
          <li className="list-item">
            <span className="photo-instructions-text1">
              Show your face clearly
            </span>
          </li>
          <li className="list-item photo-instructions-li1">
            <span className="photo-instructions-text2">
              No mater if you are wearing glasses, unless it were sunglasses.
            </span>
          </li>
          <li className="list-item photo-instructions-li2">
            <span className="photo-instructions-text3">
              You don&apos;t need to smile, just show your really mood. 
            </span>
          </li>
        </ul>
        <Link to="/photo" className='menu-button-container'>
          <button className="button photo-instructions-button">Close</button>
        </Link>
      </div>
      <PhotoHolder rootClassName="photo-holder-root-class-name2" />
      <div className="photo-instructions-container2">
        <img
          alt="image"
          src="/playground_assets/camera.png"
          className="photo-instructions-image"
        />
      </div>
    </div>
  )
}

export default PhotoInstructions
